import React from 'react';

import { Trans } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';

import { useScorecard } from '../Scorecard';
import { TotalQuestionsProps } from '../types';

function TotalQuestions(props: TotalQuestionsProps) {
  const { variant = 'body-short-02', color = 'text-text-secondary', className } = props;
  const [scorecard] = useScorecard();

  if (!scorecard?.questions) {
    return null;
  }

  const totalQuestions = scorecard?.questions?.length;

  return (
    <Typography className={className} color={color} variant={variant}>
      {totalQuestions}{' '}
      <Trans
        i18nKey="Exercise:Question"
        values={{
          count: totalQuestions,
        }}
      />
    </Typography>
  );
}

export default React.memo(TotalQuestions);
